export const LEGACY_THEME_COLOR = '#012643';

export const THEME_COLORS = [
  { name: 'Mặc định', value: LEGACY_THEME_COLOR },
  { name: 'Xanh thép', value: '#2F6F9F' },
  { name: 'Xanh đá phiến', value: '#496A8E' },
  { name: 'Indigo trầm', value: '#4F5D9D' },
  { name: 'Xanh ngọc', value: '#217C7E' },
  { name: 'Xanh rừng', value: '#3D7A5A' },
  { name: 'Mận trầm', value: '#755C8C' },
  { name: 'Burgundy', value: '#8A4155' },
] as const;

const HEX_COLOR_PATTERN = /^#[0-9A-Fa-f]{6}$/;

export const normalizePrimaryColor = (color?: string | null): string =>
  color && HEX_COLOR_PATTERN.test(color) ? color.toUpperCase() : LEGACY_THEME_COLOR;

const mix = (hex: string, target: number, amount: number): string => {
  const color = normalizePrimaryColor(hex).slice(1);
  const channels = [0, 2, 4].map((index) => {
    const value = Number.parseInt(color.slice(index, index + 2), 16);
    return Math.round(value + (target - value) * amount)
      .toString(16)
      .padStart(2, '0');
  });
  return `#${channels.join('')}`.toUpperCase();
};

export const getThemeColors = (primaryColor?: string | null) => {
  const primary = normalizePrimaryColor(primaryColor);
  if (primary === LEGACY_THEME_COLOR) {
    return {
      primary,
      primary50: '#EBF3FE',
      primary100: '#C2D8FC',
      primary300: '#7CABF9',
      primary32: '#C0D7FC',
      primary600: '#3676E0',
      primary700: '#2A5CAF',
      primary900: '#098D94',
      primaryDark: '#012643',
    };
  }
  return {
    primary,
    primary50: mix(primary, 255, 0.92),
    primary100: mix(primary, 255, 0.76),
    primary300: mix(primary, 255, 0.38),
    primary32: mix(primary, 255, 0.7),
    primary600: mix(primary, 0, 0.1),
    primary700: mix(primary, 0, 0.28),
    primary900: mix(primary, 0, 0.45),
    primaryDark: mix(primary, 0, 0.68),
  };
};

export const applyCompanyTheme = (primaryColor?: string | null): void => {
  const colors = getThemeColors(primaryColor);
  const root = document.documentElement.style;
  root.setProperty('--primaryColor', colors.primaryDark);
  root.setProperty('--primaryColor50', colors.primary50);
  root.setProperty('--primaryColor100', colors.primary100);
  root.setProperty('--primaryColor300', colors.primary300);
  root.setProperty('--primaryColor500', colors.primary);
  root.setProperty('--primaryColor32', colors.primary32);
  root.setProperty('--primaryColor600', colors.primary600);
  root.setProperty('--primaryColor700', colors.primary700);
  root.setProperty('--primaryColor900', colors.primary900);
  root.setProperty(
    '--headerColor',
    normalizePrimaryColor(primaryColor) === LEGACY_THEME_COLOR ? LEGACY_THEME_COLOR : colors.primary,
  );
  root.setProperty('--hoverColor', `${colors.primary}CC`);
};
